import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";

export const Container = styled.div`
  display: flex;
  width: 90%;
  flex-direction: column;
  height: 100%;
  margin-left: 5%;
  margin-top: 50px;
  gap: 16px;
`;

export const ContainerPages = styled.div`
  // display: flex;

  /* width: 98%; */
  /* height: 100%; */
  justify-content: center;
  align-items: center;

  position: relative;

  /* margin-left: 1%; */
`;

export const ButtonTab = styled.button<{
  active: boolean;
  disabled: boolean;
}>`
  border: 1px solid ${Colors.borderMenu};
  padding: 12px 16px 12px 16px;
  gap: 6px;
  // font-family: 'Work Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-decoration: none;
  color: ${({ active, disabled }) =>
    active ? Colors.white : disabled ? Colors.borderMenu : Colors.black};
  background-color: ${({ active }) => (active ? Colors.primary : Colors.inactiveTabMenu)};

  cursor: ${({ disabled, active }) => (disabled && !active ? "not-allowed" : "pointer")};

  &:hover {
    background-color: ${Colors.hoverTabMenu};
  }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 44px;
`;

export const OptionsContainer = styled.div`
  padding: 0;
  margin: 0;
  width: 100%;
`;

// Container do título e botão
export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContribuinteContainer = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${Colors.label};
`;

export const ContribuinteName = styled.span`
  color: ${Colors.primary};
  background-color: ${Colors.contribuinteNameBackground};
  padding: 2px 6px;
  border-radius: 4px;
`;

export const ContainerButton = styled.div`
  display: flex;
  margin-left: auto;
  gap: 16px;
`;

export const ContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
`;
